"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var CouponApi = /** @class */ (function () {
    function CouponApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 获取可领取优惠券
     * @method GET 获取可领取优惠券
     *
     */
    CouponApi.prototype.valid = function () {
        return this.http
            .url("/api/Coupon/valid")
            .support('GET');
    };
    /**
     * 查询优惠券,添加优惠券
     * @method GET 查询优惠券
     * @method POST 添加优惠券
     *
     */
    CouponApi.prototype.Coupon = function () {
        return this.http
            .url("/api/Coupon")
            .addSecurityHeaders()
            .support('GET', 'POST');
    };
    /**
     * 获取指定Id的优惠券
     * @method GET 获取指定Id的优惠券
     *
     */
    CouponApi.prototype.ids = function () {
        return this.http
            .url("/api/Coupon/ids")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 修改优惠券,删除优惠券
     * @method PUT 修改优惠券
     * @method DELETE 删除优惠券
     *
     * @params id 无说明
     */
    CouponApi.prototype.CouponById = function (id) {
        return this.http
            .url("/api/Coupon/" + id)
            .addSecurityHeaders()
            .support('PUT', 'DELETE');
    };
    /**
     * 发送优惠券
     * @method POST 发送优惠券
     *
     * @params id 无说明
     */
    CouponApi.prototype.sendto = function (id) {
        return this.http
            .url("/api/Coupon/" + id + "/sendto")
            .addSecurityHeaders()
            .support('POST');
    };
    CouponApi.diOptions = di_1.default.options({
        name: "CouponApi",
        scope: "Singleton"
    });
    return CouponApi;
}());
exports.CouponApi = CouponApi;
exports.default = CouponApi;
